import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { CategoryOptionId, CategoryOptionResponse } from '@business/entities/category_option';

export function all(withTrashed) {
  const params = R.objectCompact({ withTrashed });
  return Endpoint.get<CategoryOptionResponse[]>(`@gc/category-options`, { params });
}

export function fetch(id: CategoryOptionId) {
  return Endpoint.get<CategoryOptionResponse>(`@gc/category-options/option/${id}`);
}

export function create(data: Partial<CategoryOptionResponse>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<CategoryOptionResponse>(`@gc/category-options`, { formData, hasFiles: true });
}

// changeNote: the reason for the change (required, kept in the Activity Log)
export function update(id: CategoryOptionId, data: Partial<CategoryOptionResponse>, changeNote: string) {
  return Endpoint.patch<CategoryOptionResponse>(`@gc/category-options/${id}`, { data: { ...data, changeNote } });
}

export function destroy(id: CategoryOptionId, changeNote: string) {
  return Endpoint.delete<void>(`@gc/category-options/${id}`, { data: { changeNote } });
}
